export default {
  login: '5',
  webTouchStart: '7',
  androidVerticalVideoFullscreen: '8',
  // data : {isPortrait: bol}
  bindPhone: '9',
  interceptBack: '10',
  closeWindow: '11',
  wechatAuthCode: '12',
  aliAuthCode: '13',
  updateFollowStatus: '50',
  refreshToken: '14',
  onOffQuickPay: '16',
  setPwd: '17',
  forgetPwd: '18',
  follower: '15',
  imageSave: '19',
  hasNotifyPermission: '20',
  appSetting: '21',
  playAudio: '22',
  updateLikeStatus: '24',
  huajinTradeType: '26',
  h5TradeDeviceInfo: '31'
  // data: {userId: str, isFollowed: bol}
}



// WEBPACK FOOTER //
// ./src/constants/action-type.js